import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifi2Bar = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M8 1.778c4.516 0 7.529 2.462 7.831 2.693L8.01 14.213H8v.01l-.009-.01-4.453-5.546L.168 4.47C.472 4.24 3.485 1.778 8 1.778"
      />
    </g>
  </svg>
)
export default SvgSignalWifi2Bar
